export const PartnerUsersConstants = {
  LoginId: "事業者ログインID",
  PartnerUser: "ユーザー管理",
  PartnerUserName: "事業者ユーザー名",
  PartnerUserEdit: "ユーザー権限編集",
  UserName: "名前",
  UserRole: "権限名",
  OfficeName: "会社／営業所",
  OfficeCount: "所属営業所数",
  AvailableOffices: "所属営業所例(参考)",
  Hyphen: "ー",
} as const;
